import {
  call,
  createAction,
  safe,
  select,
  takeEvery,
  takeLeading,
} from "starfx";

import { EMenuCmdTab } from "@app/state/constants";
import { ThunkCtx } from "@app/types";

import { schema } from "../schema";
import { xThunk } from "../xapis";

import type { Next } from "starfx";
type TButtonGroupPayload = {
  currentPage: number;
  currentChild: number;
};
import type { TContractorFormSource } from "@app/types/insider";
export const uiSetButtonGroup_withSyncOption = createAction(
  `uiButtons/setButtonGroupJson`
);

export const cchSetCurrentPage = xThunk.create<number>(
  "/thks/cchSetCurrentPage",
  { supervisor: takeEvery },
  function* (ctx: ThunkCtx, next: Next) {
    const state = yield* select(schema.categoryChooser.select);
    const tabGroup = state.items.filter((x) => x.id === ctx.payload)[0].tabs;
    const firstTab = tabGroup[0] as EMenuCmdTab;
    yield* schema.update([
      schema.categoryChooser.update({ key: "currentPage", value: ctx.payload }),
    ]);

    //raw send to delphi
    if (process.env.REACT_APP_MODE === "DELPHI") {
      const delphiPayload = {
        tabGroup,
        pushed: firstTab,
      };

      const delphi = yield* call(() => window?.delphiRequire("Jurnal_Quick"));
      yield* safe(() =>
        delphi.app.assetStore(
          JSON.stringify({
            type: uiSetButtonGroup_withSyncOption.toString(),
            payload: JSON.stringify(delphiPayload),
          })
        )
      );
    } else {
      yield* schema.update([
        schema.uiJGBrowserHeader.update({
          key: "tabsAvailable",
          value: tabGroup,
        }),
        schema.uiJGBrowserHeader.update({
          key: "tabSelected",
          value: firstTab,
        }),
      ]);
    }

    yield* next();
  }
);
/*   
with frmDateFF do
  begin
    fe_id := feid;
    ff_id := ffid;
    EmtId := emt_id;
    la_data := data_facturii;
    Show;
  end; */

// type TTMirror = keyof typeof SPV_CONTRACTOR_MIRROR;
export const fxReacttSelectedMirrorecContractor =
  xThunk.create<TContractorFormSource>(
    // xThunk.create<TTMirror>(
    "/thks/react/selectedMirroredContractor1",
    { supervisor: takeLeading },
    function* (ctx: ThunkCtx, next: Next) {
      yield* schema.update([
        schema.uiSpvGrid.update({
          key: "selectedCtorMirrorTab",
          value: ctx.payload,
        }),
      ]);
      yield* next();
    }
  );

export const fxRectSelectedTab = xThunk.create<EMenuCmdTab>(
  "/thks/react/selectedTab",
  { supervisor: takeLeading },
  function* (ctx: ThunkCtx, next: Next) {
    yield* schema.update([
      schema.uiJGBrowserHeader.update({
        key: "tabSelected",
        value: ctx.payload,
      }),
    ]);
    yield* next();
  }
);

export const fxReactSelectedPage = xThunk.create<number>(
  "/thks/react/selectedPage",
  { supervisor: takeLeading },
  function* (ctx: ThunkCtx, next: Next) {
    yield* schema.update([
      schema.categoryChooser.update({
        key: "currentChild",
        value: ctx.payload,
      }),
    ]);

    yield* next();
  }
);
